import { mergeDeepRight } from 'ramda'
import UIElements from '../../../consts/UIElements'

const THEMES_STYLES = {
  KIHNU: {
    color: 'black',
  },
  SEAJETS: {
    color: 'black',
  },
  POSIDONIA: {
    color: 'black',
  },
}

const defaultLabelStyles = {
  color: 'white',
  textTransform: 'uppercase',
}

export const labelStyles = mergeDeepRight(defaultLabelStyles, THEMES_STYLES[UIElements.APP_NAME] || {})
